module.exports = __webpack_public_path__ + "static/media/margherita.a9752985.jpg";